import { Injectable } from '@angular/core';
import { Location, PlatformLocation } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { UtilsService } from '../../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class FetchApiService {
	private authHeader = 'X-Access-Token';

	constructor(
		private readonly keycloak: KeycloakService,
		private readonly utility: UtilsService,
		private readonly location: Location,
		private readonly platformLocation: PlatformLocation,
		private route: ActivatedRoute
	) {}

	async simpleStreamingRequest(url: string, method: string, requestParams?: { [p: string]: string }): Promise<Response> {
		const headers = await this.generateHeader();

		return fetch(this.createParamsFromObject(url, requestParams).toString(), {
			method: method,
			headers: headers,
		});
	}

	async bodyStreamingRequest<Q>(url: string, method: string, body: Q, queryParams?: { [p: string]: string | string[] } | null): Promise<Response> {
		const headers = await this.generateHeader({ 'Content-Type': 'Application/json' });

		return fetch(this.createParamsFromObject(url, queryParams).toString(), {
			method: method,
			headers: headers,
			body: JSON.stringify(body),
		});
	}

	async generateHeader(requestHeaders?: { [p: string]: string }): Promise<Headers> {
		const url = window.location.origin + this.platformLocation.getBaseHrefFromDOM() + this.location.prepareExternalUrl(this.route.snapshot['_routerState'].url);
		const isLoggedIn = await this.keycloak.isLoggedIn();
		if (!isLoggedIn || this.keycloak.isTokenExpired()) {
			await this.keycloak.login({
				redirectUri: url,
			});
		}

		const token = await this.keycloak.getToken();
		const headers = new Headers();
		headers.append(this.authHeader ? this.authHeader : 'Authorization', 'Bearer ' + token);
		if (requestHeaders) {
			Object.keys(requestHeaders).forEach((key) => {
				headers.append(key, requestHeaders[key]);
			});
		}

		return headers;
	}

	private createParamsFromObject<T>(baseUrl: string, dto: T): URL {
		const url = new URL(baseUrl);

		Object.keys(dto).forEach((key) => {
			const value: unknown = dto[key];
			if (value instanceof Set && value.size > 0) {
				url.searchParams.append(key, Array.from(value).join(','));
			} else if (value != null) {
				switch (typeof value) {
					case 'bigint':
					case 'string':
					case 'number':
					case 'boolean':
						url.searchParams.append(key, value.toString());
						break;
				}
			}
		});
		return url;
	}
}
